import React, { Component } from "react";
import moment from "moment";

import { getLoggedInUser } from "../../helpers/authUtils";
import {
    firebaseAuth,
    firebaseFire as Libfirebase,
    firebaseStorage
} from "../../helpers/firebase-config";
import Resposta from "../Resposta";

export default class ComentarioContent extends Component {
    componentDidMount() {

        const { idPaciente, comentario } = this.props;


    }
    componentWillUnmount() {
        this.forceUpdate();

    }

    state = {
        isVisible: false,
        resposta: "",
        dataProf: "",
        vb: false
    };

    _setVisibility = (ev) => {
        this.setState({ vb: !this.state.vb });
        //this.state.vb = !this.state.vb;    

    };

    handleChange = event => {
        this.setState({ resposta: event.target.value });
    };


    _setResposta = async (idComentario, idHistorico, idPaciente, resposta) => {

        const profissional = getLoggedInUser();
        const refProfissional = await Libfirebase.collection("usuario").doc(
            profissional.cpf
        );



        Libfirebase.collection("paciente")
            .doc(idPaciente)
            .collection("historico")
            .doc(idHistorico)
            .collection("Comentarios")
            .doc(idComentario)
            .collection("Resposta")
            .add({
                resposta,
                refProfissional,
                dataHoraCriacao: parseInt(moment().unix()),
                data: moment().format("YYYY-MM-DD HH:mm:ss")
            })
            .then(() => {
                this.setState({
                    openModal: true,
                    resposta: "",
                    notifition: true,
                    msg: "Resposta inserida com sucesso!",
                    nameclass: "alert-success"
                });
                this.props.objPai.setState({
                    openModal: true,
                    resposta: "",
                    notifition: true,
                    msg: "Resposta inserida com sucesso!",
                    nameclass: "alert-success"
                });
                this.props.update();
                this._setVisibility();
            })
            .catch(error => {

                this.setState({
                    notifition: true,
                    msg: error.code,
                    nameclass: "alert-danger"
                });
            });
    };

    render() {
        let ref = null;
        const { coment, index, idPaciente, idHistorico, dataProf, referencia } = this.props;
        if (referencia)
            ref = referencia.data();
        return (


            <div key={index} className="row " style={{
                padding: '0px !important', margin: '0px !important', marginTop: '5px', marginBottom: '7px'
            }}>

                <div className="col-sm-2 text-right">

                    <img
                        src={
                            coment.profissional.avatarURL
                                ? coment.profissional.avatarURL
                                : "https://firebasestorage.googleapis.com/v0/b/globalbrain-ba498.appspot.com/o/images%2Fno-user.jpg?alt=media&token=44616cc9-46e2-40ea-906f-28e46f58fb68"
                        }
                        style={{
                            width: '52px',

                        }}
                        alt="Imagem do Profissional"
                        className="rounded-circle img-fluid"
                    />

                </div>

                <div className="col-sm-8"

                    style={{
                        borderBottom: '1px solid #d3d3d3'

                    }}>


                    <label>
                        {coment.profissional.nome}
                        {coment.profissional.CRM ? (
                            <label
                                className="mt-1"
                                style={{
                                    fontSize: 11.5,
                                    color: "gray",
                                    marginTop: -10
                                }}
                            >
                                - {`CRM: ${coment.profissional.CRM}`}
                            </label>
                        ) : null}
                        {' '}
                        <small>
                            <i>
                                {moment(coment.comentario.data).format(
                                    "DD/MM/YYYY HH:mm:ss"
                                )}
                            </i>
                        </small>

                    </label>
                    {ref ? (
                        <div

                            style={{
                                fontStyle: 'italic',
                                fontSize: '11px',
                                padding: '11px',
                                backgroundColor: '#FFF1D8',
                                color: '#999',
                                border: '1px solid #FFD205',
                                display: 'block'
                            }}
                        >
                            {'Em resposta ao comentário: '}
                            {ref.comentario.substring(0, 10) + "...  em  "}
                            {moment(ref.comentario.dataHoraCriacao).format(
                                "DD/MM/YYYY HH:mm:ss"
                            )}
                        </div>
                    ) : null}
                    <p>
                        {coment.comentario.comentario}

                    </p>
                    <a href="#" onClick={(ev) => { this._setVisibility(ev); }}>Responder</a>
                    {this.state.vb ?
                        (
                            <p>
                                <input type="text"
                                    className="form-control"

                                    placeholder="Digite o seu comentário..."
                                    onChange={e => this.handleChange(e)}
                                    value={this.props.Txtcomentario}
                                    style={{
                                        display: 'inline-block',
                                        width: '80%',
                                        borderRight: 'none'
                                    }}
                                />

                                <button
                                    style={{
                                        display: 'inline-block',
                                        height: '38px',
                                        marginTop: '-2px',
                                        marginLeft: '-2px'
                                    }}
                                    onClick={(ev) => { this.props._setComentario(this.state.resposta); this._setVisibility(ev); }}
                                    type="button"
                                    className="btn waves-effect waves-light btn-secondary btn-sm"
                                >
                                    Responder <i className="fas fa-paper-plane"></i>
                                </button>
                            </p>
                        ) : null}
                </div>


            </div>
        );
    }
}